export default "__VITE_ASSET__B$$r4YdY__"